import  create from "../uril/requwst";
//连接
export function ping(data){
    //get 请求=》params
    return create({
        url:"/func/ping/",
        method:"post",
        data
    })
}
//获取用户作业批改历史
export function workhistoryget(params){
    //get 请求=》params
    return create({
        url:"work/workhistory/",
        method:"get",
        params:params
    })
}
//获取用户作业批改历史
export function map(params){
    //get 请求=》params
    return create({
        url:"work/map/",
        method:"get",
        params:params
    })
}

//删除作文批改历史
export function workhistorydelete(data){
    //get 请求=》params
    return create({
        url:"/work/workhistory/",
        method:"delete",
        data
    })
}
//查看作文批改详情
export function workxqget(params){
    //get 请求=》params
    return create({
        url:"work/workxq/",
        method:"get",
        params:params
    })
}
//历史
export function historyget(params){
    //get 请求=》params
    return create({
        url:"/his/history/",
        method:"get",
        params:params
    })
}
//删除history 数据
export function historydelete(data){
    //get 请求=》params
    return create({
        url:"/his/history/",
        method:"delete",
        data
    })
}
//添加书签
export function bookmarkpost(data){
    //get 请求=》params
    return create({
        url:"/his/history/book/",
        method:"post",
        data
    })
}
export function funcconjunctionspost(data){
    //get 请求=》params
    return create({
        url:"/func/conjunctions/",
        method:"post",
        data
    })
}
//删除书签
export function bookmarkdelete(data){
    //get 请求=》params
    return create({
        url:"/his/history/book/",
        method:"delete",
        data
    })
}
//音频上传获取音频接口

export function uppost(data){
    //get 请求=》params
    return create({
        url:"/audio/up/",
        method:"post",
        data
    })
}
//获取音频历史记录详情：
export function xqget(params){
    //get 请求=》params
    return create({
        url:"/audio/xq/",
        method:"get",
        params:params
    })
}
//获取上传对话音频历史记录：
export function obtainget(params){
    //get 请求=》params
    return create({
        url:"/audio/obtain/",
        method:"get",
        params:params
    })
}
//删除音频历史记录：
export function obtaindelete(data){
    //get 请求=》params
    return create({
        url:"/audio/obtain/",
        method:"delete",
        data
    })
}
//绘图
export function drawpost(data){
    //get 请求=》params
    return create({
        url:"/pro/draw/",
        method:"post",
        data
    })
}
//绘图历史
export function drawhistoryget(params){
    //get 请求=》params
    return create({
        url:"/pro/draw/history/",
        method:"get",
        params:params
    })
}
//绘图历史详情
export function drawhistorygetxq(params){
    //get 请求=》params
    return create({
        url:"/pro/draw/history/xq/",
        method:"get",
        params:params
    })
}
//删除图片历史记录：
export function historydrawdelete(data){
    //get 请求=》params
    return create({
        url:"/pro/draw/history/",
        method:"delete",
        data
    })
}

//修改ls
export function historyPUT(data){
    //get 请求=》params
    return create({
        url:"/his/history/",
        method:"PUT",
        data
    })
}
//修改ls

//卡通合影历史
export function imghisget(params){
    //get 请求=》params
    return create({
        url:"/avatar/img/his/",
        method:"get",
        params:params
    })
}
//卡通合影历史删除：
export function imghisdelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/img/his/",
        method:"delete",
        data
    })
}
//魔法贴纸获取历史数据：
export function histzget(params){
    //get 请求=》params
    return create({
        url:"/avatar/tz/his/",
        method:"get",
        params:params
    })
}
//卡通合影历史删除：
export function zthisdelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/tz/his/",
        method:"delete",
        data
    })
}
// cat获取对话记录

export function toolsget3(params){
    //get 请求=》params
    return create({
        url:"/patrick/history/",
        method:"get",
        params:params
    })
}
// cat获取对话记录详情

export function historyxq(params){
    //get 请求=》params
    return create({
        url:"/patrick/history/xq/",
        method:"get",
        params:params
    })
}
//删除对话记录
export function deldelete(data){
    //get 请求=》params
    return create({
        url:"/patrick/history/del/",
        method:"delete",
        data
    })
}
//邀请码
export function userinvite(params){
    //get 请求=》params
    return create({
        url:"/invite/user/invite/",
        method:"get",
        params:params
    })
}
// /登陆主页邀请人的头像和信息
export function byuserget(params){
    //get 请求=》params
    return create({
        url:"/invite/by/user/",
        method:"get",
        params:params
    })
}
// 价格
export function orderssub(params){
    //get 请求=》params
    return create({
        url:"/orders/sub/",
        method:"get",
        params:params
    })
}
// 套餐
export function ordersgetsub(params){
    //get 请求=》params
    return create({
        url:"/orders/get/sub/",
        method:"get",
        params:params
    })
}

// 订单
export function orderorders( params){
    //get 请求=》params
    return create({
        url:"/orders/get/sub/",
        method:"get",
      
        params
    })
}
// 订单详情支付
export function ordersgetorder(data){
    //get 请求=》params
    return create({
        url:"/pay/wechat/",
        method:"post",
        data
    })
}
// 支付
export function paywechat( data){
    //get 请求=》params
    return create({
        url:"/orders/order/",
        method:"post",
        data
    })
}
export function ordersswitchingpost( data){
    //get 请求=》params
    return create({
        url:"/orders/switching/",
        method:"post",
        data
    })
}
// 循环请求
export function getordersts( params){
    //get 请求=》params
    return create({
        url:"/orders/get/order/sts/",
        method:"get",
        params:params
    })
}
// 循环访问是否支付
export function ordersgetordersts( params){
    //get 请求=》params
    return create({
        url:"/orders/get/order/sts/",
        method:"get",
        params:params
    })
}
// 邀请列表
export function inviteinvite( params){
    //get 请求=》params
    return create({
        url:"/invite/invite/",
        method:"get",
        params:params
    })
}
// 用户列表
export function getorders( params){
    //get 请求=》params
    return create({
        url:"/orders/get/order/list/",
        method:"get",
        params:params
    })
}

// 激活码
export function invitebycode(  data){
    //get 请求=》params
    return create({
        url:"/invite/by/code/",
        method:"post",
        data
    })
}
// 添加支付宝账号
export function invitealipay(  data){
    //get 请求=》params
    return create({
        url:"/invite/alipay/",
        method:"post",
        data
    })
}
//删除表单
export function delorder(data){
    //get 请求=》params
    return create({
        url:"/orders/del/order/",
        method:"delete",
        data
    })
}

// 提现接口
export function invitesharelink( params){
    //get 请求=》params
    return create({
        url:"/invite/sharelink/",
        method:"get",
        params:params
    })
}
// 单词配音接口
export function voiceword(data){
    //get 请求=》params
    return create({
        url:"/voice/word/",
        method:"post",
        data
    })
}
// 单词配音历史接口
export function voicewordget(params){
    //get 请求=》params
    return create({
        url:"/voice/word/",
        method:"get",
        params
    })
}

//删除单词配音历史接口
export function voiceworddelete(data){
    //get 请求=》params
    return create({
        url:"/voice/word/",
        method:"delete",
        data
    })
}



// 文章配音接口
export function voicearticle(data){
    //get 请求=》params
    return create({
        url:"/voice/article/",
        method:"post",
        data
    })
}

// 文章配音历史接口
export function voicearticleget(params){
    //get 请求=》params
    return create({
        url:"/voice/article/",
        method:"get",
        params
    })
}

//删除文章配音历史接口
export function voicearticledelete(data){
    //get 请求=》params
    return create({
        url:"/voice/article/",
        method:"delete",
        data
    })
}

// 文本导出单词接口
export function newtoossession(data){
    //get 请求=》params
    return create({
        url:"/newtoos/session/",
        method:"post",
        data
    })
}

// 文本导出单词历史接口
export function newtoossessionget(params){
    //get 请求=》params
    return create({
        url:"/newtoos/session/",
        method:"get",
        params
    })
}

//删除文本导出单词历史接口
export function newtoossessiondelete(data){
    //get 请求=》params
    return create({
        url:"/newtoos/session/",
        method:"delete",
        data
    })
}
// 文本导出word文档接口
export function newtoosdocxpost(data){
    //get 请求=》params
    return create({
        url:"/newtoos/docx/",
        method:"post",
        data
    })
}
//反复调用故事配图
export function prodrawget(params){
    //get 请求=》params
    return create({
        url:"/pro/draw/get/",
        method:"get",
        params
    })
}
//反复调用卡通合影
export function avatarimgget(params){
    //get 请求=》params
    return create({
        url:"/avatar/img/get/",
        method:"get",
        params
    })
}
//反复调用卡通合影
export function avatartzget(params){
    //get 请求=》params
    return create({
        url:"/avatar/tz/get/",
        method:"get",
        params
    })
}
//反复调用卡通合影
export function vipp(params){
    //get 请求=》params
    return create({
        url:"/user/vip/",
        method:"get",
        params
    })
}
//时间
export function user(params){
    //get 请求=》params
    return create({
        url:"/user/second/",
        method:"get",
        params
    })
}
// 获取卷妮历史     
export function patrickjanehistory(params){
    //get 请求=》params
    return create({
        url:"/patrick/jane/history/",
        method:"get",
        params
    })
}
//  获取卷妮历史详情    
export function patrickjanehistoryxq(params){
    //get 请求=》params
    return create({
        url:"/patrick/jane/history/xq/",
        method:"get",
        params
    })
}
//删除卷妮历史   
export function janehistorydel(data){
    //get 请求=》params
    return create({
        url:"/patrick/jane/history/del/",
        method:"delete",
        data
    })
}
//  获取svg历史详情    
export function funcsvgget(params){
    //get 请求=》params
    return create({
        url:"/func/svg/",
        method:"get",
        params
    })
}
//删除卷妮历史   
export function workmapdelete(data){
    //get 请求=》params
    return create({
        url:"/work/map/",
        method:"delete",
        data
    })
}
//  获取svg历史详情    
export function mapxqwork(params){
    //get 请求=》params
    return create({
        url:"/work/mapxq/",
        method:"get",
        params
    })
}
//  获取svg历史详情    
export function mapxqsvgmap(params){
    //get 请求=》params
    return create({
        url:"/work/svgmap/",
        method:"get",
        params
    })
}






//删除pet历史   
export function workpetdelete(data){
    //get 请求=》params
    return create({
        url:"/work/pet/",
        method:"delete",
        data
    })
}

//  获取pet历史  
export function petwork(params){
    //get 请求=》params
    return create({
        url:"/work/pet/",
        method:"get",
        params
    })
}
export function petaitext(params){
    //get 请求=》params
    return create({
        url:"/work/aitext/",
        method:"get",
        params
    })
}
//删除pet历史   
export function workketdelete(data){
    //get 请求=》params
    return create({
        url:"/work/ket/",
        method:"delete",
        data
    })
}
export function woraitextdelete(data){
    //get 请求=》params
    return create({
        url:"/work/aitext/",
        method:"delete",
        data
    })
}

//  获取pet历史  
export function ketwork(params){
    //get 请求=》params
    return create({
        url:"/work/ket/",
        method:"get",
        params
    })
}
//  获取pet历史详情
export function petxq(params){
    //get 请求=》params
    return create({
        url:"/work/petxq/",
        method:"get",
        params
    })
}
export function aitextxq(params){
    //get 请求=》params
    return create({
        url:"/work/aitextxq/",
        method:"get",
        params
    })
}
//  获取ket历史详情
export function ketxq(params){
    //get 请求=》params
    return create({
        url:"/work/ketxq/",
        method:"get",
        params
    })
}

    //get 请求=newtoos
export function newtoossqc(params){
    return create({
        url:"/newtoos/sqc/",
        method:"get",
        params
    })
}








//删除KET历史   
export function ketworkmapdelete(data){
    //get 请求=》params
    return create({
        url:"/work/map/",
        method:"delete",
        data
    })
}

//  获取KET历史详情    
export function ketmapxqwork(params){
    //get 请求=》params
    return create({
        url:"/work/mapxq/",
        method:"get",
        params
    })
}
//  获取KET历史详情    
export function ketmapxqsvgmap(params){
    //get 请求=》params
    return create({
        url:"/work/svgmap/",
        method:"get",
        params
    })
}
// 文本导出word文档接口
export function newtoosdocxmap3post(data){
    //get 请求=》params
    return create({
        url:"chat-map3",
        method:"post",
        data
    })
}



//删除K电子文档归纳总结
export function ketworkdocdelete(data){
    //get 请求=》params
    return create({
        url:"/work/doc/",
        method:"delete",
        data
    })
}


//  获取电子文档归纳总结历史   
export function ketmapxqdoc(params){
    //get 请求=》params
    return create({
        url:"/work/doc/",
        method:"get",
        params
    })
}
//  获取电子文档归纳总结历史详情    
export function ketmdocxqsvgmap(params){
    //get 请求=》params
    return create({
        url:"/work/docxq/",
        method:"get",
        params
    })
}
//音频
export function mp(data){
    //get 请求=》params
    return create({
        url:"/work/mp/",
        method:"post",
        data
    })
}
//微信

export function wechat(params){
    //get 请求=》params
    return create({
        url:"/extra/wechat/",
        method:"get",
        params
    })
}












// 后台营销：
//  有效注册用户接口
export function wholeadmin(params){
    //get 请求=》params
    return create({
        url:"/extra/whole/",
        method:"get",
        params
    })
}
//  过去24小时有效注册用户接口
export function adminnew(params){
    //get 请求=》params
    return create({
        url:"/extra/new/",
        method:"get",
        params
    })
}

// 充值用户与未充值用户接口
export function adminvip(params){
    //get 请求=》params
    return create({
        url:"/extra/vip/",
        method:"get",
        params
    })
}

// 20小时即将到期用户接口
export function adminexp(params){
    //get 请求=》params
    return create({
        url:"/extra/exp/",
        method:"get",
        params
    })
}

// 通过邮箱查询用户的有效邀请的人数
export function adminsearch(params){
    //get 请求=》params
    return create({
        url:"/extra/search/",
        method:"get",
        params
    })
}
// 认证问题
export function volumen(params){
    //get 请求=》params
    return create({
        url:"/vlo/volumen/",
        method:"get",
        params
    })
}

// 认证问题
export function vlovolumen(data){
    //get 请求=》params
    return create({
        url:"/vlo/volumen/",
        method:"post",
        data
    })
}

// 邮箱用户添加
export function addvip(params){
    //get 请求=》params
    return create({
        url:"extra/add/vip/",
        method:"get",
        params
    })
}
// 邮箱用户添加时间
export function adminvippost(data){
    //get 请求=》params
    return create({
        url:"extra/add/vip/ ",
        method:"post",
        data
    })
}

// 邮箱用户删除时间
export function vipdelete(data){
    //get 请求=》params
    return create({
        url:"extra/add/vip/ ",
        method:"delete",
        data
    })
}






//ppt    生成内容
export function generatepost(data){
    //get 请求=》params
    return create({
        url:"/ppt/generate/ ",
        method:"post",
        data
    })
}
// ppt  获取内容
export function generateget(params){
    //get 请求=》params
    return create({
        url:"/ppt/generate/",
        method:"get",
        params
    })
}
// ppt 历史记录
export function ppthistoryget(params){
    //get 请求=》params
    return create({
        url:"/ppt/history/",
        method:"get",
        params
    })
}

// 邮箱用户删除时间
export function pptgeneratedelete(data){
    //get 请求=》params
    return create({
        url:"/ppt/generate/",
        method:"delete",
        data
    })
}
// ppt 用户
export function admintime(params){
    //get 请求=》params
    return create({
        url:"/extra/time/",
        method:"get",
        params
    })
}
// ppt 用户
export function script(params){
    //get 请求=》params
    return create({
        url:"/extra/script/",
        method:"get",
        params
    })
}
export function thank(params){
    //get 请求=》params
    return create({
        url:"/extra/thank/",
        method:"get",
        params
    })
}
//邀请用户
export function invite(params){
    //get 请求=》params
    return create({
        url:"/extra/invite/",
        method:"get",
        params
    })
}


//AIPOSU
export function aipost(data){
    //get 请求=》params
    return create({
        url:"/func/content/",
        method:"post",
        data
    })
}

//支付POSU
export function content(data){
    //get 请求=》params
    return create({
        url:"/orders/wchat/order/public/",
        method:"post",
        data
    })
}

//用户的chat使用排序前20条
export function token(params){
    //get 请求=》params
    return create({
        url:"/extra/token/",
        method:"get",
        params
    })
}
//单词默写连读
export function condastent(data){
    //get 请求=》params
    return create({
        url:"/func/mp3/",
        method:"post",
        data
    })
}
//单词默写连读
export function condastentget(params){
    //get 请求=》params
    return create({
        url:"/func/mp3/",
        method:"get",
        params
    })
}
export function condastentdelete(data){
    //get 请求=》params
    return create({
        url:"/func/mp3/",
        method:"delete",
        data
    })
}

export function funcnum(params){
    //get 请求=》params
    return create({
        url:"/func/num/",
        method:"get",
        params
    })
}
export function functsk(params){
    //get 请求=》params
    return create({
        url:"/func/tsk/",
        method:"get",
        params
    })
}

export function functskpost(data){
    //get 请求=》params
    return create({
        url:"/func/tsk/",
        method:"post",
        data
    })
}
//发送短信
export function usersendpost(data){
    //get 请求=》params
    return create({
        url:"/user/send/",
        method:"post",
        data
    })
}
//发送短信
export function usercodepost(data){
    //get 请求=》params
    return create({
        url:"/user/code/",
        method:"post",
        data
    })
}
//生成儿歌
export function musicgeneratepost(data){
    //get 请求=》params
    return create({
        url:"/music/generate/",
        method:"post",
        data
    })
}
// 获取儿歌
export function musicgeneratgete(params){
    //get 请求=》params
    return create({
        url:"/music/generate/",
        method:"get",
        params
    })
}
    //# 获取儿歌历史记录
    export function musicuserget(params){
        //get 请求=》params
        return create({
            url:"/music/user/",
            method:"get",
            params
        })
    }
    // 获取儿歌详情
export function musicusergpost(data){
    //get 请求=》params
    return create({
        url:"/music/user/",
        method:"post",
        data
    })
}

//删除儿歌
export function musicuserdelete(data){
    //get 请求=》params
    return create({
        url:"/music/user/",
        method:"delete",
        data
    })
}
//删除儿歌
export function musicseniorget(params){
    //get 请求=》params
    return create({
        url:"/music/senior/",
        method:"get",
        params
    })
}
export function musicnumget(params){
    //get 请求=》params
    return create({
        url:"/music/num/",
        method:"get",
        params
    })
}
//手机号
export function musicnumgetnumd(params){
    //get 请求=》params
    return create({
        url:"/music/yz/",
        method:"get",
        params
    })
}
// 验证码
export function musicnumgetnumdss(data){
    //get 请求=》params
    return create({
        url:"/music/get/",
        method:"post",
        data
    })
}
// 验证
export function musicnumgetaanumd(data){
    //get 请求=》params
    return create({
        url:"/music/gpt/",
        method:"post",
        data
    })
}
export function musicsend(data){
    //get 请求=》params
    return create({
        url:"/music/send/",
        method:"post",
        data
    })
}
export function musicnumgeasdtnumd(params){
    //get 请求=》params
    return create({
        url:"/music/look/",
        method:"get",
        params
    })
}
//10分钟刷新
export function musidddaa(params){
    //get 请求=》params
    return create({
        url:"/user/inspect/",
        method:"get",
        params
    })
}
export function funcfunc(data){
    //get 请求=》params
    return create({
        url:"/func/multiple/",
        method:"post",
        data
    })
}

   //# 获取儿歌历史记录
   export function funcmultipleget(params){
    //get 请求=》params
    return create({
        url:"/func/multiple/",
        method:"get",
        params
    })
}

//删除儿歌
export function uncmultidelete(data){
//get 请求=》params
return create({
    url:"/func/multiple/",
    method:"delete",
    data
})
}

export function funcpropost(data){
    //get 请求=》params
    return create({
        url:"/func/pro/",
        method:"post",
        data
    })
}

   //# 获取儿歌历史记录
   export function funcproget(params){
    //get 请求=》params
    return create({
        url:"/func/pro/",
        method:"get",
        params
    })
}

//删除儿歌
export function prodelete(data){
//get 请求=》params
return create({
    url:"/func/pro/",
    method:"delete",
    data
})
}
//闪卡
export function funnukpost(data){
    //get 请求=》params
    return create({
        url:"/func/nuk/",
        method:"post",
        data
    })
}
export function funnukPUT(data){
    //get 请求=》params
    return create({
        url:"/func/nuk/",
        method:"PUT",
        data
    })
}
export function funngptkpost(data){
    //get 请求=》params
    return create({
        url:"/func/gpt/",
        method:"post",
        data
    })
}
export function funngptkpostee(data){
    //get 请求=》params
    return create({
        url:"/sticker/gpt/",
        method:"post",
        data
    })
}
export function stickerspainpost(data){
    //get 请求=》params
    return create({
        url:"/sticker/spain/",
        method:"post",
        data
    })
}
export function stickernnidget(params){
    //get 请求=》params
    return create({
        url:"/sticker/nnid/",
        method:"get",
        params
    })
}
export function stickerspainhistoryget(params){
    //get 请求=》params
    return create({
        url:"/sticker/spainhistory/",
        method:"get",
        params
    })
}
//闪卡详情和全部历史记录

   export function funcprogetd(params){
    //get 请求=》params
    return create({
        url:"/func/nuk/",
        method:"get",
        params
    })
}
  


//删除闪卡
export function funcprodeletea(data){
//get 请求=》params
return create({
    url:"/func/nuk/",
    method:"delete",
    data
})
}


export function funcprogptget(params){
    //get 请求=》params
    return create({
        url:"/func/gpt/",
        method:"get",
        params
    })
}
export function funcprognumptget(params){
    //get 请求=》params
    return create({
        url:"/func/nuk/num/",
        method:"get",
        params
    })
}
export function sotrygenerate(data){
    //get 请求=》params
    return create({
        url:"/sotry/generate/",
        method:"post",
        data
    })
}

export function sotrygeneratgete(params){
    //get 请求=》params
    return create({
        url:"/sotry/generate/",
        method:"get",
        params
    })
}
export function sotrygeneratgeteid(params){
    //get 请求=》params
    return create({
        url:"/sotry/generate/id/",
        method:"get",
        params
    })
}


//删除闪卡
export function sotrygeneratedelete(data){
//get 请求=》params
return create({
    url:"/sotry/generate/",
    method:"delete",
    data
})
}

export function newtoosasbpost(data){
    //get 请求=》params
    return create({
        url:"/newtoos/asb/",
        method:"post",
        data
    })
}


export function newtoosasbget(params){
    //get 请求=》params
    return create({
        url:"/newtoos/asb/",
        method:"get",
        params
    })
}


//删除闪卡
export function newtoosasbdelete(data){
//get 请求=》params
return create({
    url:"/newtoos/asb/",
    method:"delete",
    data
})
}


//手机登录发短信
export function phonesendpost(data){
    //get 请求=》params
    return create({
        url:"/phone/send/",
        method:"post",
        data
    })
}


//手机登录
export function phoneloginpost(data){
    //get 请求=》params
    return create({
        url:"/phone/login/",
        method:"post",
        data
    })
}
export function studentgeneratepost(data){
    //get 请求=》params
    return create({
        url:"/student/generate/",
        method:"post",
        data
    })
}
export function studentputpost(data){
    //get 请求=》params
    return create({
        url:"/student/put/",
        method:"post",
        data
    })
}


export function studentgenerateget(params){
    //get 请求=》params
    return create({
        url:"/student/generate/",
        method:"get",
        params
    })
}


export function studentgeneratePUT(data){
    //get 请求=》params
    return create({
        url:"/student/generate/",
        method:"PUT",
        data
    })
}

export function funcceget(params){
    //get 请求=》params
    return create({
        url:"/func/ce/",
        method:"get",
        params
    })
}
export function funccepost(data){
    //get 请求=》params
    return create({
        url:"/func/ce/",
        method:"post",
        data
    })
}
export function funccegdet(params){
    //get 请求=》params
    return create({
        url:"/func/ce2/",
        method:"get",
        params
    })
}
export function funccegiddet(params){
    //get 请求=》params
    return create({
        url:"/audio/id/",
        method:"get",
        params
    })
}
export function funcnnidget(params){
    //get 请求=》params
    return create({
        url:"/func/nnid/",
        method:"get",
        params
    })
}
export function funccepdost(data){
    //get 请求=》params
    return create({
        url:"/func/ce2/",
        method:"post",
        data
    })
}
export function funcstick(data){
    //get 请求=》params
    return create({
        url:"/func/stick/",
        method:"post",
        data
    })
}
export function studenthistoryxq(params){
    //get 请求=》params
    return create({
        url:"/student/history/xq/",
        method:"get",
        params
    })
}
export function studenthistory(params){
    //get 请求=》params
    return create({
        url:"/student/history/",
        method:"get",
        params
    })
}
//修改口令
export function userpspost(data){
    //get 请求=》params
    return create({
        url:"/user/ps/",
        method:"post",
        data
    })
}
//添加服务群：
export function userroompost(data){
    //get 请求=》params
    return create({
        url:"/user/room/",
        method:"post",
        data
    })
}

//获取口令
export function userpsget(params){
    //get 请求=》params
    return create({
        url:"/user/ps/",
        method:"get",
        params
    })
}
//获取服务群：
export function userroomget(params){
    //get 请求=》params
    return create({
        url:"/user/room/",
        method:"get",
        params
    })
}
//修改群名字
export function userroomPUT(data){
    //get 请求=》params
    return create({
        url:"/user/room/",
        method:"PUT",
        data
    })
}



export function toolsget31(params){
    //get 请求=》params
    return create({
        url:"/patrick/ai/history/",
        method:"get",
        params:params
    })
}

// cat获取对话记录详情

export function historyxq1(params){
    //get 请求=》params
    return create({
        url:"/patrick/ai/history/xq/",
        method:"get",
        params:params
    })
}
export function funcmultiplehc(params){
    //get 请求=》params
    return create({
        url:"/func/multiple/hc/",
        method:"get",
        params:params
    })
}
export function agentcodeyz(params){
    //get 请求=》params
    return create({
        url:"/agent/code/yz/",
        method:"get",
        params:params
    })
}
export function ordersroll(params){
    //get 请求=》params
    return create({
        url:"/orders/roll/",
        method:"get",
        params:params
    })
}

//删除对话记录
export function deldelete1(data){
    //get 请求=》params
    return create({
        url:"/patrick/ai/history/del/",
        method:"delete",
        data
    })
}

export function studenttopic(data){
    //get 请求=》params
    return create({
        url:"/student/topic/",
        method:"post",
        data
    })
}

export function studenttopicget(params){
    //get 请求=》params
    return create({
        url:"/student/topic/",
        method:"get",
        params:params
    })
}

export function studenttopicdelete(data){
    //get 请求=》params
    return create({
        url:"/student/topic/",
        method:"delete",
        data
    })
}


export function fcework(params){
    //get 请求=》params
    return create({
        url:"/work/fce/",
        method:"get",
        params
    })
}
//  获取pet历史详情
export function fcexq(params){
    //get 请求=》params
    return create({
        url:"/work/fcexq/",
        method:"get",
        params
    })
}

export function wfceetdelete(data){
    //get 请求=》params
    return create({
        url:"/work/fce/",
        method:"delete",
        data
    })
}
export function avatarstickerspost(data){
    //get 请求=》params
    return create({
        url:"/avatar/stickers/",
        method:"post",
        data
    })
}
export function avatarstickersget(params){
    //get 请求=》params
    return create({
        url:"/avatar/stickers/",
        method:"get",
        params
    })
}
export function avatarstickersgethis(params){
    //get 请求=》params
    return create({
        url:"/avatar/stickers/his/",
        method:"get",
        params
    })
}
export function musicfilgete(params){
    //get 请求=》params
    return create({
        url:"/music/file/",
        method:"get",
        params
    })
}
export function usergettime(params){
    //get 请求=》params
    return create({
        url:"/user/time/",
        method:"get",
        params
    })
}
export function avatarstickehideletesrs(data){
    //get 请求=》params
    return create({
        url:"/avatar/stickers/his/",
        method:"delete",
        data
    })
}
export function musicfildeletee(data){
    //get 请求=》params
    return create({
        url:"/music/file/",
        method:"delete",
        data
    })
}

export function studenttpostosendpic(data){
    //get 请求=》params
    return create({
        url:"/student/topic/send/",
        method:"post",
        data
    })
}
export function voicpostesuper(data){
    //get 请求=》params
    return create({
        url:"/voice/super/",
        method:"post",
        data
    })
}


export function voicsupereget(params){
    //get 请求=》params
    return create({
        url:"/voice/super/",
        method:"get",
        params
    })
}
export function supevdeleteoicer(data){
    //get 请求=》params
    return create({
        url:"/voice/super/",
        method:"delete",
        data
    })
}








//生成单词卡接口：

export function func1gppostt(data){
    //get 请求=》params
    return create({
        url:"/sticker/generate/",
        method:"post",
        data
    })
}
export function voicesupercustomdatapost(data){
    //get 请求=》params
    return create({
        url:"/voice/supercustom/",
        method:"post",
        data
    })
}

//查找图片接口：
export function fungetcgpt1(params){
    //get 请求=》params
    return create({
        url:"/sticker/gpt/",
        method:"get",
        params
    })
}
//查看历史记录接口：
export function funcget1gpgett(params){
    //get 请求=》params
    return create({
        url:"/sticker/generate/",
        method:"get",
        params
    })
}
//查看历史记录详情接口：
export function func1gptgetget(params){
    //get 请求=》params
    return create({
        url:"/sticker/generate/",
        method:"get",
        params
    })
}
//剩余次数接口：
export function func1gptasdfgetget(params){
    //get 请求=》params
    return create({
        url:"/sticker/num/",
        method:"get",
        params
    })
}
//删除历史记录接口：
export function func1dgptelete(data){
    //get 请求=》params
    return create({
        url:"/sticker/generate/",
        method:"delete",
        data
    })
}

export function wordgeneratgete(params){
    //get 请求=》params
    return create({
        url:"/word/generate/",
        method:"get",
        params
    })
}
//删除历史记录接口：
export function wordgeneratedelete(data){
    //get 请求=》params
    return create({
        url:"/word/generate/",
        method:"delete",
        data
    })
}


export function wordgenerapostte(data){
    //get 请求=》params
    return create({
        url:"/word/generate/",
        method:"post",
        data
    })
}
export function separatesepostparate(data){
    //get 请求=》params
    return create({
        url:"/separate/separate/",
        method:"post",
        data
    })
}
export function separatesgeteparate(params){
    //get 请求=》params
    return create({
        url:"/separate/separate/",
        method:"get",
        params
    })
}
export function cvocabulpostaryard(data){
    //get 请求=》params
    return create({
        url:"/vocabulary/card/",
        method:"post",
        data
    })
}

export function vocabularcgetardy(params){
    //get 请求=》params
    return create({
        url:"/vocabulary/card/",
        method:"get",
        params
    })
}
export function vocabularcgetahisrdy(params){
    //get 请求=》params
    return create({
        url:"/vocabulary/card/his/",
        method:"get",
        params
    })
}
export function vocabularycdeleteard(data){
    //get 请求=》params
    return create({
        url:"/vocabulary/card/his/",
        method:"delete",
        data
    })
}
export function ordersmupostsic(data){
    //get 请求=》params
    return create({
        url:"/orders/music/",
        method:"post",
        data
    })
}
export function avatarwordillustrationspost(data){
    //get 请求=》params
    return create({
        url:"/avatar/wordillustrations/",
        method:"post",
        data
    })
}
export function avatarwordillustrationsreviserpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/wordillustrations/reviser/",
        method:"post",
        data
    })
}

export function avatarwordillustrationsget(data){
    //get 请求=》params
    return create({
        url:"/avatar/wordillustrations/",
        method:"get",
        data
    })
}
// #子账号购买
export function orderssonpost(data){
    //get 请求=》params
    return create({
        url:"/orders/son/",
        method:"post",
        data
    })
}
// #子账号续费：
export function ordersxfpost(data){
    //get 请求=》params
    return create({
        url:"/orders/xf/",
        method:"post",
        data
    })
}
// #子账号登录：
export function usersonlogipostn(data){
    //get 请求=》params
    return create({
        url:"/user/son/login/",
        method:"post",
        data
    })
}
// #子账号登录：
export function ordersnumpost(data){
    //get 请求=》params
    return create({
        url:"/orders/num/",
        method:"post",
        data
    })
}
// #子账号登录：
export function avatartaskwordpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/task-word/",
        method:"post",
        data
    })
}
export function avatarwordillustrationschangepost(data){
    //get 请求=》params
    return create({
        url:"/avatar/wordillustrations/change/",
        method:"post",
        data
    })
}
export function avatarwordillustrationschangeget(params){
    //get 请求=》params
    return create({
        url:"/avatar/wordillustrations/change/",
        method:"get",
        params:params
    })
}
// 查看子账号：
export function usersonget(params){
    //get 请求=》params
    return create({
        url:"/user/son/",
        method:"get",
        params:params
    })
}
// 修改子账号：
export function usersonPUT(data){
    //get 请求=》params
    return create({
        url:"/user/son/",
        method:"PUT",
        data
    })
}

// 查看子账号：
export function funcmdget(params){
    //get 请求=》params
    return create({
        url:"/func/md/",
        method:"get",
        params:params
    })
}
export function funcmdnumget(params){
    //get 请求=》params
    return create({
        url:"/func/md/num/",
        method:"get",
        params:params
    })
}
export function funcmdinfoget(params){
    //get 请求=》params
    return create({
        url:"/func/md/info/",
        method:"get",
        params:params
    })
}

export function apimdpost(data){
    //get 请求=》params
    return create({
        url:"/api/md/",
        method:"post",
        data
    })
}
export function procustopostm(data){
    //get 请求=》params
    return create({
        url:"func/pro/custom/",
        method:"post",
        data
    })
}
export function funcmp3custompost(data){
    //get 请求=》params
    return create({
        url:"func/mp3/custom/",
        method:"post",
        data
    })
}
export function funcadasdkajsompost(data){
    //get 请求=》params
    return create({
        url:"/voice/custom/",
        method:"post",
        data
    })
}
export function jsadfhafgas(data){
    //get 请求=》params
    return create({
        url:"/audio/custom/",
        method:"post",
        data
    })
}


export function studentwokerget(params){
    //get 请求=》params
    return create({
        url:"/student/woker/",
        method:"get",
        params:params
    })
}
export function studentwokerall(params){
    //get 请求=》params
    return create({
        url:"/student/woker/all/",
        method:"get",
        params:params
    })
}

export function studentwokerchangedelete(data){
    //get 请求=》params
    return create({
        url:"/student/woker/change/",
        method:"delete",
        data
    })
}

export function studentwokerchangePUT(data){
    //get 请求=》params
    return create({
        url:"/student/woker/change/",
        method:"PUT",
        data
    })
}
export function studentwokerevaluatePUT(data){
    //get 请求=》params
    return create({
        url:"/student/woker/evaluate/",
        method:"PUT",
        data
    })
}
export function studentwokerpost(data){
    //get 请求=》params
    return create({
        url:"/student/woker/",
        method:"post",
        data
    })
}


export function studentwokerlistget(params){
    //get 请求=》params
    return create({
        url:"/student/woker/list/",
        method:"get",
        params:params
    })
}
export function avatarcustominfoget(params){
    //get 请求=》params
    return create({
        url:"/avatar/custom/info/",
        method:"get",
        params:params
    })
}
export function voiceqrwordget(params){
    //get 请求=》params
    return create({
        url:"/voice/qrword/",
        method:"get",
        params:params
    })
}

export function avatarcustompost(data){
    //get 请求=》params
    return create({
        url:"/avatar/custom/",
        method:"post",
        data
    })
}
export function avatarcustominfopost(data){
    //get 请求=》params
    return create({
        url:"/avatar/custom/info/",
        method:"post",
        data
    })
}
export function voiceqrwordpost(data){
    //get 请求=》params
    return create({
        url:"/voice/qrword/",
        method:"post",
        data
    })
}
export function voiceqrwordpost2(data){
    //get 请求=》params
    return create({
        url:"/voice/qrword2/",
        method:"post",
        data
    })
}


export function avatarcustominfodelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/custom/info/",
        method:"delete",
        data
    })
}

export function funccleaninginfodelete(data){
    //get 请求=》params
    return create({
        url:"/func/cleaning/info/",
        method:"delete",
        data
    })
}

export function voiceqrsentencposte(data){
    //get 请求=》params
    return create({
        url:"/voice/qrsentence/",
        method:"post",
        data
    })
}
export function funccleaningpost(data){
    //get 请求=》params
    return create({
        url:"/func/cleaning/",
        method:"post",
        data
    })
}
export function funccleaningget(params){
    //get 请求=》params
    return create({
        url:"/func/cleaning/",
        method:"get",
        params:params
    })
}
export function voiceqrwordget2(params){
    //get 请求=》params
    return create({
        url:"/voice/qrword2/",
        method:"get",
        params:params
    })
}
export function funccleaninginfo(params){
    //get 请求=》params
    return create({
        url:"/func/cleaning/info/",
        method:"get",
        params:params
    })
}
export function funcextendget(params){
    //get 请求=》params
    return create({
        url:"/func/extend/",
        method:"get",
        params:params
    })
}
export function mdtopdffuncpost(data){
    //get 请求=》params
    return create({
        url:"/func/mdtopdf/",
        method:"post",
        data:data
    })
}
export function avatarspeaking(data){
    //get 请求=》params
    return create({
        url:"/avatar/speaking/",
        method:"post",
        data:data
    })
}
export function avatarspeakingget(params){
    //get 请求=》params
    return create({
        url:"/avatar/speaking/",
        method:"get",
        params:params
    })
}
export function avatarspeakingdelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/speaking/",
        method:"delete",
        data
    })
}
export function avatarspeakinggetpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/speaking/get/",
        method:"post",
        data:data
    })
}
export function avatarspeakingcardpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/speaking/card/",
        method:"post",
        data:data
    })
}
export function avatarebbinghaus(data){
    //get 请求=》params
    return create({
        url:"/avatar/ebbinghaus/",
        method:"post",
        data:data
    })
}
export function funcextendhxpost(data){
    //get 请求=》params
    return create({
        url:"/func/extend/hx/",
        method:"post",
        data:data
    })
}
export function funcextendhxget(params){
    //get 请求=》params
    return create({
        url:"/func/extend/hx/",
        method:"get",
        params:params
    })
}
export function funcsmalpostl(data){
    //get 请求=》params
    return create({
        url:"/func/small/",
        method:"post",
        data:data
    })
}
export function funcextendpost(data){
    //get 请求=》params
    return create({
        url:"/func/extend/",
        method:"post",
        data:data
    })
}
export function voiceimgpost(data){
    //get 请求=》params
    return create({
        url:"/voice/img/",
        method:"post",
        data:data
    })
}

export function patrickdpxqget(params){
    //get 请求=》params
    return create({
        url:"/patrick/dp/xq/",
        method:"get",
        params:params
    })
}

// 导出一个名为 patrickdpget 的函数，该函数用于发送 GET 请求
export function patrickdpget(params){
    //get 请求=》params
    return create({
        url:"/patrick/dp/",
        method:"get",
        params:params
    })
}
export function ordersnewsubget(params){
    //get 请求=》params
    return create({
        url:"/orders/newsub/",
        method:"get",
        params:params
    })
}
export function ordersmodelget(params){
    //get 请求=》params
    return create({
        url:"/orders/model/",
        method:"get",
        params:params
    })
}
export function patrickdpdel(data){
    //get 请求=》params
    return create({
        url:"/patrick/dp/del/",
        method:"delete",
        data
    })
}


export function approvemagicpost(data){
    //get 请求=》params
    return create({
        url:"/approve/magic/",
        method:"post",
        data:data
    })
}

// 音频,视频二维码生成器容量获取
export function approvemagicCapacity(params){
    //get 请求=》 params
    return create({
        url:"/music/storage_capacity/",
        method:"get",
        params
    })
}

export function approveoralpost(data){
    //get 请求=》params
    return create({
        url:"/approve/oral/",
        method:"post",
        data:data
    })
}
export function approvehomeworkpost(data){
    //get 请求=》params
    return create({
        url:"/approve/homework/",
        method:"post",
        data:data
    })
}
export function approveimagespost(data){
    //get 请求=》params
    return create({
        url:"/approve/images/",
        method:"post",
        data:data
    })
}
export function approvegradedpost(data){
    //get 请求=》params
    return create({
        url:"/approve/graded/",
        method:"post",
        data:data
    })
}
export function funcknowledgepost(data){
    //get 请求=》params
    return create({
        url:"/func/knowledge/",
        method:"post",
        data:data
    })
}
export function funcknowledgeget(params){
    //get 请求=》params
    return create({
        url:"/func/knowledge/",
        method:"get",
        params:params
    })
}
export function funcknowledgeuserget(params){
    //get 请求=》params
    return create({
        url:"/func/knowledgeuser/",
        method:"get",
        params:params
    })
}
export function funcknowledgeuserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/knowledgeuser/",
        method:"delete",
        data
    })
}
export function funcreadingget(params){
    //get 请求=》params
    return create({
        url:"/func/reading/",
        method:"get",
        params:params
    })
}
export function funcreadingdelete(data){
    //get 请求=》params
    return create({
        url:"/func/reading/",
        method:"delete",
        data
    })
}
export function funcdiggingouthxpost(data){
    //get 请求=》params
    return create({
        url:"/func/diggingout/hx/",
        method:"post",
        data:data
    })
}
export function funcdiggingouthxget(params){
    //get 请求=》params
    return create({
        url:"/func/diggingout/hx/",
        method:"get",
        params:params
    })
}
export function funcdiggingoutpost(data){
    //get 请求=》params
    return create({
        url:"/func/diggingout/",
        method:"post",
        data:data
    })
}

export function funcdiggingoutget(params){
    //get 请求=》params
    return create({
        url:"/func/diggingout/",
        method:"get",
        params:params
    })
}
export function gamewordspost(data){
    //get 请求=》params
    return create({
        url:"/game/words/",
        method:"post",
        data:data
    })
}
export function gamedatapost(data){
    //get 请求=》params
    return create({
        url:"/game/data/",
        method:"post",
        data:data
    })
}
export function gamewordsget(params){
    //get 请求=》params
    return create({
        url:"/game/words/",
        method:"get",
        params:params
    })
}
export function gamedataget(params){
    //get 请求=》params
    return create({
        url:"/game/data/",
        method:"get",
        params:params
    })
}

export function gamedataPUT(data){
    //get 请求=》params
    return create({
        url:"/game/data/",
        method:"PUT",
        data
    })
}
export function gamedatadelete(data){
    //get 请求=》params
    return create({
        url:"/game/data/",
        method:"delete",
        data
    })
}

export function funcextendtwopost(data){
    //get 请求=》params
    return create({
        url:"func/extend/two/",
        method:"post",
        data:data
    })
}
export function funcextendreusetwopost(data){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/two/",
        method:"post",
        data:data
    })
}

export function funcextendthreepost(data){
    //get 请求=》params
    return create({
        url:"func/extend/three/",
        method:"post",
        data:data
    })
}
export function funcextendthreereusepost(data){
    //get 请求=》params
    return create({
        url:"func/extendreuse/three/",
        method:"post",
        data:data
    })
}
export function funcextendthreereusepost1(data){
    //get 请求=》params
    return create({
        url:"/func/tedhtml/",
        method:"post",
        data:data
    })
}
export function funcextendfourpost(data){
    //get 请求=》params
    return create({
        url:"func/extend/four/",
        method:"post",
        data:data
    })
}
export function funcextendreusefourpost(data){
    //get 请求=》params
    return create({
        url:"func/extendreuse/four/",
        method:"post",
        data:data
    })
}
export function gamenewpost(data){
    //get 请求=》params
    return create({
        url:"/game/new/",
        method:"post",
        data:data
    })
}
export function gamenewget(params){
    //get 请求=》params
    return create({
        url:"/game/new/",
        method:"get",
        params:params
    })
}
export function gamegetget(params){
    //get 请求=》params
    return create({
        url:"/game/get/",
        method:"get",
        params:params
    })
}

export function gamegetdelete(data){
    //get 请求=》params
    return create({
        url:"/game/get/",
        method:"delete",
        data
    })
}


export function asfasfasaapost(data){
    //get 请求=》params
    return create({
        url:"/game/think/",
        method:"post",
        data:data
    })
}
export function gamethinkqhpost(data){
    //get 请求=》params
    return create({
        url:"/game/think/qh/",
        method:"post",
        data:data
    })
}
export function asdsaffasaasget(params){
    //get 请求=》params
    return create({
        url:"/game/think/",
        method:"get",
        params:params
    })
}
export function gamethinkqhget(params){
    //get 请求=》params
    return create({
        url:"/game/think/qh/",
        method:"get",
        params:params
    })
}

export function gamethinkqhdelete(data){
    //get 请求=》params
    return create({
        url:"/game/think/qh/",
        method:"delete",
        data
    })
}
export function gamethinkusertwodelete(data){
    //get 请求=》params
    return create({
        url:"/game/thinkusertwo/",
        method:"delete",
        data
    })
}

export function asdfsfdfgk(data){
    //get 请求=》params
    return create({
        url:"/func/sentence/",
        method:"post",
        data:data
    })
}

export function asffdsggsd(params){
    //get 请求=》params
    return create({
        url:"/func/sentence/",
        method:"get",
        params:params
    })
}
export function funcunpost(data){
    //get 请求=》params
    return create({
        url:"/func/un/",
        method:"post",
        data:data
    })
}

export function funcunget(params){
    //get 请求=》params
    return create({
        url:"/func/un/",
        method:"get",
        params:params
    })
}
export function funcpicturepost(data){
    //get 请求=》params
    return create({
        url:"/func/picture/",
        method:"post",
        data:data
    })
}

export function funcpictureget(params){
    //get 请求=》params
    return create({
        url:"/func/picture/",
        method:"get",
        params:params
    })
}

export function funccorrectionpost(data){
    //get 请求=》params
    return create({
        url:"/func/correction/",
        method:"post",
        data:data
    })
}

export function funccorrectionget(params){
    //get 请求=》params
    return create({
        url:"/func/correction/",
        method:"get",
        params:params
    })
}
export function funcconnectionpost(data){
    //get 请求=》params
    return create({
        url:"/func/connection/",
        method:"post",
        data:data
    })
}

export function funcconnectionget(params){
    //get 请求=》params
    return create({
        url:"/func/connection/",
        method:"get",
        params:params
    })
}
export function funcmultipost(data){
    //get 请求=》params
    return create({
        url:"/func/multi/",
        method:"post",
        data:data
    })
}

export function funcmultiget(params){
    //get 请求=》params
    return create({
        url:"/func/multi/",
        method:"get",
        params:params
    })
}
export function functranslatepost(data){
    //get 请求=》params
    return create({
        url:"/func/translate/",
        method:"post",
        data:data
    })
}

export function functranslateget(params){
    //get 请求=》params
    return create({
        url:"/func/translate/",
        method:"get",
        params:params
    })
}
export function funcmultidelete(data){
    //get 请求=》params
    return create({
        url:"/func/multi/",
        method:"delete",
        data
    })
}


export function funcadvancedget(params){
    //get 请求=》params
    return create({
        url:"/func/advanced/",
        method:"get",
        params:params
    })
}
export function funcadvancedpost(data){
    //get 请求=》params
    return create({
        url:"/func/advanced/",
        method:"post",
        data:data
    })
}

export function funcadvanceduserget(params){
    //get 请求=》params
    return create({
        url:"/func/advanceduser/",
        method:"get",
        params:params
    })
}
export function funcadvanceduserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/advanceduser/",
        method:"delete",
        data
    })
}




export function gamesentencethinkget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethink/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkclickget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclick/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkpost(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethink/",
        method:"post",
        data:data
    })
}
export function gamesentencethinkclickpost(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclick/",
        method:"post",
        data:data
    })
}
export function sentencethinkqhpost(data){
    //get 请求=》params
    return create({
        url:"game/sentencethink/qh/",
        method:"post",
        data:data
    })
}

export function gamesentencethinkqhget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethink/qh/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkclickqhget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclick/qh/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkqhdelete(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethink/qh/",
        method:"delete",
        data
    })
}
export function gamesentencethinkclickqhdelete(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclick/qh/",
        method:"delete",
        data
    })
}


export function gametwopost(data){
    //get 请求=》params
    return create({
        url:"/game/two/",
        method:"post",
        data:data
    })
}
export function gametwoput(data){
    //get 请求=》params
    return create({
        url:"/game/two/",
        method:"put",
        data:data
    })
}

export function gametwoget(params){
    //get 请求=》params
    return create({
        url:"/game/two/",
        method:"get",
        params:params
    })
}
export function gametwouserget(params){
    //get 请求=》params
    return create({
        url:"/game/twouser/",
        method:"get",
        params:params
    })
}
export function gametwouserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/twouser/",
        method:"delete",
        data
    })
}











export function gamethreepost(data){
    //get 请求=》params
    return create({
        url:"/game/three/",
        method:"post",
        data:data
    })
}

export function gamethreeget(params){
    //get 请求=》params
    return create({
        url:"/game/three/",
        method:"get",
        params:params
    })
}
export function gamethreeuserget(params){
    //get 请求=》params
    return create({
        url:"/game/threeuser/",
        method:"get",
        params:params
    })
}
export function gamethreeuserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/threeuser/",
        method:"delete",
        data
    })
}

export function funcknowledgeuserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/knowledgeuser/",
        method:"PUT",
        data
    })
}
export function funcadvanceduserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/advanceduser/",
        method:"PUT",
        data
    })
}



export function gameconjunctionsformsentencespost(data){
    //get 请求=》params
    return create({
        url:"/game/conjunctionsformsentences/",
        method:"post",
        data:data
    })
}

export function gameconjunctionsformsentencesget(params){
    //get 请求=》params
    return create({
        url:"/game/conjunctionsformsentences/",
        method:"get",
        params:params
    })
}
export function gameconjunctionsformsentencesuserget(params){
    //get 请求=》params
    return create({
        url:"/game/conjunctionsformsentencesuser/",
        method:"get",
        params:params
    })
}
export function gameconjunctionsformsentencesuserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/conjunctionsformsentencesuser/",
        method:"delete",
        data
    })
}



export function gamedubpropost(data){
    //get 请求=》params
    return create({
        url:"/game/dubpro/",
        method:"post",
        data:data
    })
}

export function gamedubproget(params){
    //get 请求=》params
    return create({
        url:"/game/dubpro/",
        method:"get",
        params:params
    })
}
export function gamedubprouserget(params){
    //get 请求=》params
    return create({
        url:"/game/dubprouser/",
        method:"get",
        params:params
    })
}
export function gamedubprouserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/dubprouser/",
        method:"delete",
        data
    })
}

export function gamethreePUT(data){
    //get 请求=》params
    return create({
        url:"/game/three/",
        method:"PUT",
        data
    })
}







export function funcadvancedthinkingpicturepost(data){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpicture/",
        method:"post",
        data:data
    })
}

export function funcadvancedthinkingpictureget(params){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpicture/",
        method:"get",
        params:params
    })
}
export function funcadvancedthinkingpictureuserget(params){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpictureuser/",
        method:"get",
        params:params
    })
}

export function funcadvancedthinkingpictureuserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpictureuser/",
        method:"delete",
        data
    })
}

export function funcculturalreadingpost(data){
    //get 请求=》params
    return create({
        url:"/func/culturalreading/",
        method:"post",
        data:data
    })
}

export function funcculturalreadingget(params){
    //get 请求=》params
    return create({
        url:"/func/culturalreading/",
        method:"get",
        params:params
    })
}
export function funcculturalreadinguserget(params){
    //get 请求=》params
    return create({
        url:"/func/culturalreadinguser/",
        method:"get",
        params:params
    })
}

export function funcculturalreadinguserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/culturalreadinguser/",
        method:"delete",
        data
    })
}

export function funcculturalreadinguserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/culturalreadinguser/",
        method:"PUT",
        data
    })
}

export function funcvideoreadingget(params){
    //get 请求=》params
    return create({
        url:"/func/videoreading/",
        method:"get",
        params:params
    })
}
export function funcvideoreadinguserget(params){
    //get 请求=》params
    return create({
        url:"/func/videoreadinguser/",
        method:"get",
        params:params
    })
}

export function funcvideoreadinguserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/videoreadinguser/",
        method:"delete",
        data
    })
}

export function funcvideoreadingpost(data){
    //get 请求=》params
    return create({
        url:"/func/videoreading/",
        method:"post",
        data
    })
}

export function funcvideoreadingcontentget(params){
    //get 请求=》params
    return create({
        url:"/func/videoreadingcontent/",
        method:"get",
        params:params
    })
}

export function funcculturalreadingimgpost(data){
    //get 请求=》params
    return create({
        url:"/func/culturalreadingimg/",
        method:"post",
        data
    })
}

export function funcculturalreadingimgget(params){
    //get 请求=》params
    return create({
        url:"/func/culturalreadingimg/",
        method:"get",
        params:params
    })
}
export function funcvideoculturalreadingimgget(params){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreadingimg/",
        method:"get",
        params:params
    })
}

export function funcvideoculturalreadingpost(data){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreading/",
        method:"post",
        data
    })
}

export function funcvideoculturalreadingget(params){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreading/",
        method:"get",
        params:params
    })
}

export function funcvideoculturalreadinguserget(params){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreadinguser/",
        method:"get",
        params:params
    })
}

export function funcvideoculturalreadinguserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreadinguser/",
        method:"PUT",
        data
    })
}
export function gameSentencefollowupusertitlePUT(data){
    //get 请求=》params
    return create({
        url:"/game/Sentencefollowupusertitle/",
        method:"PUT",
        data
    })
}
export function funcvideoculturalreadinguserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/videoculturalreadinguser/",
        method:"delete",
        data
    })
}

export function gamepyramidlistpost(data){
    //get 请求=》params
    return create({
        url:"/game/pyramidlist/",
        method:"post",
        data
    })
}

export function gamepyramidlistget(params){
    //get 请求=》params
    return create({
        url:"/game/pyramidlist/",
        method:"get",
        params:params
    })
}
export function gamepyramidLlistuserget(params){
    //get 请求=》params
    return create({
        url:"/game/pyramidLlistuser/",
        method:"get",
        params:params
    })
}

export function gamepyramidLlistuserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/pyramidLlistuser/",
        method:"delete",
        data
    })
}
export function gamethinktwopost(data){
    //get 请求=》params
    return create({
        url:"/game/thinktwo/",
        method:"post",
        data
    })
}

export function gamethinktwoget(params){
    //get 请求=》params
    return create({
        url:"/game/thinktwo/",
        method:"get",
        params:params
    })
}
export function gamethinkusertwoget(params){
    //get 请求=》params
    return create({
        url:"/game/thinkusertwo/",
        method:"get",
        params:params
    })
}
export function funcadvancedthinkingpicturetwopost(data){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpicturetwo/",
        method:"post",
        data
    })
}

export function funcadvancedthinkingpicturetwoget(params){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpicturetwo/",
        method:"get",
        params:params
    })
}
export function funcadvancedthinkingpictureusertwoget(params){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpictureusertwo/",
        method:"get",
        params:params
    })
}
export function funcadvancedthinkingpictureusertwodelete(data){
    //get 请求=》params
    return create({
        url:"/func/advancedthinkingpictureusertwo/",
        method:"delete",
        data
    })
}

export function orderspromotionpost(data){
    //get 请求=》params
    return create({
        url:"/orders/promotion/",
        method:"post",
        data
    })
}

export function ordersgetorderstsget(params){
    //get 请求=》params
    return create({
        url:"/orders/get/order/sts/",
        method:"get",
        params:params
    })
}


export function funcextendreusehxget(data){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/hx/",
        method:"post",
        data
    })
}

export function funcextendreusehx(params){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/hx/",
        method:"get",
        params:params
    })
}

export function funcextendreuseget(params){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/",
        method:"get",
        params:params
    })
}

export function funcextendreusepost(data){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/",
        method:"post",
        data:data
    })
}

export function funcreadingreuseget(params){
    //get 请求=》params
    return create({
        url:"/func/readingreuse/",
        method:"get",
        params:params
    })
}
export function funcreadingreuseget1(params){
    //get 请求=》params
    return create({
        url:"/func/tedhtml/",
        method:"get",
        params:params
    })
}

export function funcreadingreusedelete(data){
    //get 请求=》params
    return create({
        url:"/func/readingreuse/",
        method:"delete",
        data
    })
}
export function funcreadingreuseput(data){
    //get 请求=》params
    return create({
        url:"/func/readingreuse/",
        method:"put",
        data
    })
}


export function gamethreeuserPUT(data){
    //get 请求=》params
    return create({
        url:"/game/threeuser/",
        method:"PUT",
        data
    })
}
export function gametwouserPUT(data){
    //get 请求=》params
    return create({
        url:"/game/twouser/",
        method:"PUT",
        data
    })
}
export function gamegetPUT(data){
    //get 请求=》params
    return create({
        url:"/game/get/",
        method:"PUT",
        data
    })
}
export function gamedatacPUT(data){
    //get 请求=》params
    return create({
        url:"/game/data/",
        method:"PUT",
        data
    })
}
export function gameconjunctionsformsentencesuserPUT(data){
    //get 请求=》params
    return create({
        url:"/game/conjunctionsformsentencesuser/",
        method:"PUT",
        data
    })
}




export function gamesentencefollowuppost(data){
    //get 请求=》params
    return create({
        url:"/game/sentencefollowup/",
        method:"post",
        data:data
    })
}

export function gamesentencefollowupget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencefollowup/",
        method:"get",
        params:params
    })
}
export function gamesentencefollowupuserget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencefollowupuser/",
        method:"get",
        params:params
    })
}

export function gamesentencefollowupuserdelete(data){
    //get 请求=》params
    return create({
        url:"/game/sentencefollowupuser/",
        method:"delete",
        data
    })
}


export function gamesentencefollowupuserPUT(data){
    //get 请求=》params
    return create({
        url:"/game/sentencefollowupuser/",
        method:"PUT",
        data
    })
}

export function avatarspainpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/spain/",
        method:"post",
        data:data
    })
}

export function avatarspainget(params){
    //get 请求=》params
    return create({
        url:"/avatar/spain/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkechopost(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkecho/",
        method:"post",
        data:data
    })
}

export function gamesentencethinkechoget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkecho/",
        method:"get",
        params:params
    })
}
export function gamesentencethinkclickechopost(data){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclickecho/",
        method:"post",
        data:data
    })
}

export function gamesentencethinkclickechoget(params){
    //get 请求=》params
    return create({
        url:"/game/sentencethinkclickecho/",
        method:"get",
        params:params
    })
}






export function gamesentencepost(data){
    //get 请求=》params
    return create({
        url:"/game/sentence/",
        method:"post",
        data:data
    })
}

export function gamesentenceget(params){
    //get 请求=》params
    return create({
        url:"/game/sentence/",
        method:"get",
        params:params
    })
}
export function gamesentenceechopost(data){
    //get 请求=》params
    return create({
        url:"/game/sentenceecho/",
        method:"post",
        data:data
    })
}

export function gamesentenceechoget(params){
    //get 请求=》params
    return create({
        url:"/game/sentenceecho/",
        method:"get",
        params:params
    })
}
export function gamesentenceinfoget(params){
    //get 请求=》params
    return create({
        url:"/game/sentenceinfo/",
        method:"get",
        params:params
    })
}

export function gamesentenceinfodelete(data){
    //get 请求=》params
    return create({
        url:"/game/sentenceinfo/",
        method:"delete",
        data
    })
}



export function gameglobalqrpost(data){
    //get 请求=》params
    return create({
        url:"/game/globalqr/",
        method:"post",
        data:data
    })
}

export function gameglobalqrget(params){
    //get 请求=》params
    return create({
        url:"/game/globalqr/",
        method:"get",
        params:params
    })
}
export function gameentrygamepost(data){
    //get 请求=》params
    return create({
        url:"/game/entrygame/",
        method:"post",
        data:data
    })
}

export function gameentrygameget(params){
    //get 请求=》params
    return create({
        url:"/game/entrygame/",
        method:"get",
        params:params
    })
}

export function gameentrygamehistoryget(params){
    //get 请求=》params
    return create({
        url:"/game/entrygamehistory/",
        method:"get",
        params:params
    })
}

export function gameentrygamehistorydelete(data){
    //get 请求=》params
    return create({
        url:"/game/entrygamehistory/",
        method:"delete",
        data
    })
}

export function gameentrygamehistoryPUT(data){
    //get 请求=》params
    return create({
        url:"/game/entrygamehistory/",
        method:"PUT",
        data
    })
}






export function gamewordlibraryget(params){
    //get 请求=》params
    return create({
        url:"/game/wordlibrary/",
        method:"get",
        params:params
    })
}
export function gamewordlibrarypost(data){
    //get 请求=》params
    return create({
        url:"/game/wordlibrary/",
        method:"post",
        data:data
    })
}


export function gamewordlibrarydelete(data){
    //get 请求=》params
    return create({
        url:"/game/wordlibrary/",
        method:"delete",
        data
    })
}

export function gamewordlibraryPUT(data){
    //get 请求=》params
    return create({
        url:"/game/wordlibrary/",
        method:"PUT",
        data
    })
}



export function avatarebbinghausget(params){
    //get 请求=》params
    return create({
        url:"/avatar/ebbinghaus/",
        method:"get",
        params:params
    })
}

export function avatarebbinghausdelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/ebbinghaus/",
        method:"delete",
        data
    })
}

export function avatarebbinghausPUT(data){
    //get 请求=》params
    return create({
        url:"/avatar/ebbinghaus/",
        method:"PUT",
        data
    })
}
export function gameentrygamePUT(data){
    //get 请求=》params
    return create({
        url:"/game/entrygame/",
        method:"PUT",
        data
    })
}
export function avatarpaperhistoryPUT(data){
    //get 请求=》params
    return create({
        url:"/avatar/paperhistory/",
        method:"PUT",
        data
    })
}

export function avatarpaperpost(data){
    //get 请求=》params
    return create({
        url:"/avatar/paper/",
        method:"post",
        data:data
    })
}

export function avatarpaperget(params){
    //get 请求=》params
    return create({
        url:"/avatar/paper/",
        method:"get",
        params:params
    })
}


export function avatarpaperhistoryget(params){
    //get 请求=》params
    return create({
        url:"/avatar/paperhistory/",
        method:"get",
        params:params
    })
}

export function avatarpaperhistorydelete(data){
    //get 请求=》params
    return create({
        url:"/avatar/paperhistory/",
        method:"delete",
        data
    })
}



export function avataremojipost(data){
    //get 请求=》params
    return create({
        url:"/avatar/emoji/",
        method:"post",
        data:data
    })
}
export function funcextendreusefourpropost(data){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/fourpro/",
        method:"post",
        data:data
    })
}

export function funcextendreusefourproget(params){
    //get 请求=》params
    return create({
        url:"/func/extendreuse/fourpro/",
        method:"get",
        params:params
    })
}
export function funcashortstoryget(params){
    //get 请求=》params
    return create({
        url:"/func/ashortstory/",
        method:"get",
        params:params
    })
}
export function funchtmlpdfpost(data){
    //get 请求=》params
    return create({
        url:"/func/htmlpdf/",
        method:"post",
        data:data
    })
}



export function funclearnget(params){
    //get 请求=》params
    return create({
        url:"/func/learn/",
        method:"get",
        params:params
    })
}
export function funclearnpost(data){
    //get 请求=》params
    return create({
        url:"/func/learn/",
        method:"post",
        data:data
    })
}


export function funclearnhistoryget(params){
    //get 请求=》params
    return create({
        url:"/func/learnhistory/",
        method:"get",
        params:params
    })
}
export function funclearnhistorydelete(data){
    //get 请求=》params
    return create({
        url:"/func/learnhistory/",
        method:"delete",
        data
    })
}

export function funclearnhistoryPUT(data){
    //get 请求=》params
    return create({
        url:"/func/learnhistory/",
        method:"PUT",
        data
    })
}
// Smart单词表修改例句
export function exampleSentences(data){
    //get 请求=》params
    return create({
        url:"/func/learn/modify/",
        method:"post",
        data:data
    })
}
// Smart单词表生成短链
export function getShortChain(params){
    //get 请求=》params
    return create({
        url:"/reading/shorturl/",
        method:"get",
        params:params

    })
}





export function funcdiversepost(data){
    //get 请求=》params
    return create({
        url:"/func/diverse/",
        method:"post",
        data:data
    })
}
export function funcdiverseget(params){
    //get 请求=》params
    return create({
        url:"/func/diverse/",
        method:"get",
        params:params
    })
}
export function funcdiverseuserget(params){
    //get 请求=》params
    return create({
        url:"/func/diverseuser/",
        method:"get",
        params:params
    })
}

export function funcdiverseuserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/diverseuser/",
        method:"delete",
        data
    })
}
export function funcdiverseuserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/diverseuser/",
        method:"PUT",
        data
    })
}
export function funcisperpost(data){
    //get 请求=》params
    return create({
        url:"/func/isper/",
        method:"post",
        data:data
    })
}





export function funcpatternpost(data){
    //get 请求=》params
    return create({
        url:"/func/pattern/",
        method:"post",
        data:data
    })
}
/**
 * 获取函数模式的请求函数
 * @param {Object} params - 请求参数对象
 * @returns {Object} 返回一个axios请求配置对象
 */
export function funcpatternget(params){
    //get 请求=》params
    return create({    // 调用create函数发起HTTP请求
        url:"/func/pattern/",
        method:"get",
        params:params    // 请求参数
    })
}

export function funcpatterngeneratepost(data){
    //get 请求=》params
    return create({
        url:"/func/patterngenerate/",
        method:"post",
        data:data
    })
}
export function funcpatterngenerateget(params){
    //get 请求=》params
    return create({
        url:"/func/patterngenerate/",
        method:"get",
        params:params
    })
}
export function funcpatternuserget(params){
    //get 请求=》params
    return create({
        url:"/func/patternuser/",
        method:"get",
        params:params
    })
}

export function funcpatternuserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/patternuser/",
        method:"delete",
        data
    })
}
export function funcpatternuserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/patternuser/",
        method:"PUT",
        data
    })
}


export function dasfaget(params){
    //get 请求=》params
    return create({
        url:"/music/filepro/",
        method:"get",
        params:params
    })
}
export function musicuserfileproget(params){
    //get 请求=》params
    return create({
        url:"/music/userfilepro/",
        method:"get",
        params:params
    })
}
export function musicuserfileprodelete(data){
    //get 请求=》params
    return create({
        url:"/music/userfilepro/",
        method:"delete",
        data
    })
}

export function musicuserfileprPUTo(data){
    //get 请求=》params
    return create({
        url:"/music/userfilepro/",
        method:"PUT",
        data
    })
}




export function funcchildenpaperpost(data){
    //get 请求=》params
    return create({
        url:"/func/childenpaper/",
        method:"post",
        data:data
    })
}
export function funcchildenpaperget(params){
    //get 请求=》params
    return create({
        url:"/func/childenpaper/",
        method:"get",
        params:params
    })
}

export function funcchildenpaperuserget(params){
    //get 请求=》params
    return create({
        url:"/func/childenpaperuser/",
        method:"get",
        params:params
    })
}
export function funcchildenpaperuserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/childenpaperuser/",
        method:"delete",
        data
    })
}

export function funcchildenpaperuserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/childenpaperuser/",
        method:"PUT",
        data
    })
}
export function funccultural2get(params){
    //get 请求=》params
    return create({
        url:"/func/cultural2/",
        method:"get",
        params:params
    })
}

export function funccultural2PUT(data){
    //get 请求=》params
    return create({
        url:"/func/cultural2/",
        method:"PUT",
        data
    })
}





export function gamelableget(params){
    //get 请求=》params
    return create({
        url:"/game/lable/",
        method:"get",
        params:params
    })
}
export function gamelablepost(data){
    //get 请求=》params
    return create({
        url:"/game/lable/",
        method:"post",
        data:data
    })
}
export function gamelabledelete(data){
    //get 请求=》params
    return create({
        url:"/game/lable/",
        method:"delete",
        data
    })
}
export function gamewordlablepost(data){
    //get 请求=》params
    return create({
        url:"/game/wordlable/",
        method:"post",
        data:data
    })
}


export function gamewordlabledelete(data){
    //get 请求=》params
    return create({
        url:"/game/wordlable/",
        method:"delete",
        data
    })
}
export function orderssdgdget(params){
    //get 请求=》params
    return create({
        url:"/orders/sdgd/",
        method:"get",
        params:params
    })
}
export function ordersoadvertisement(data){
    //get 请求=》params
    return create({
        url:"/orders/oadvertisement/",
        method:"post",
        data:data
    })
}

export function ordersstsget(params){
    //get 请求=》params
    return create({
        url:"/orders/sts/",
        method:"get",
        params:params
    })
}
export function funcsingpost(data){
    //get 请求=》params
    return create({
        url:"/func/sing/",
        method:"post",
        data:data
    })
}

export function funcsingget(params){
    //get 请求=》params
    return create({
        url:"/func/sing/",
        method:"get",
        params:params
    })
}

export function funcsinguserget(params){
    //get 请求=》params
    return create({
        url:"/func/singuser/",
        method:"get",
        params:params
    })
}

export function funcsinguserPUT(data){
    //get 请求=》params
    return create({
        url:"/func/singuser/",
        method:"PUT",
        data
    })
}
export function funcsinguserdelete(data){
    //get 请求=》params
    return create({
        url:"/func/singuser/",
        method:"delete",
        data
    })
}
export function funcqrcodeadpostd(data){
    //get 请求=》params
    return create({
        url:"/func/qrcodeadd/",
        method:"post",
        data:data
    })
}
export function funcqrcodeaddget(params){
    //get 请求=》params
    return create({
        url:"/func/qrcodeadd/",
        method:"get",
        params:params
    })
}
export function gamecrzypdfpost(data){
    //get 请求=》params
    return create({
        url:"/game/crzypdf/",
        method:"post",
        data:data
    })
}
export function gamecrzypdfget(params){
    //get 请求=》params
    return create({
        url:"/game/crzypdf/",
        method:"get",
        params:params
    })
}
export function funcqrcodeaddpatch(data){
    //get 请求=》params
    return create({
        url:"/func/qrcodeadd/",
        method:"patch",
       data
    })
}

export function funcqrcodeaddPUT(data){
    //get 请求=》params
    return create({
        url:"/func/qrcodeadd/",
        method:"PUT",
        data
    })
}
export function funcqrcodeadddelete(data){
    //get 请求=》params
    return create({
        url:"/func/qrcodeadd/",
        method:"delete",
        data
    })
}

export function funccartoonpost(data){
    //get 请求=》params
    return create({
        url:"/func/cartoon/",
        method:"post",
        data:data
    })
}
export function funccartoonget(params){
    //get 请求=》params
    return create({
        url:"/func/cartoon/",
        method:"get",
        params:params
    })
}

export function funcsimplepost(data){
    //get 请求=》params
    return create({
        url:"/func/simple/",
        method:"post",
        data
    })
}
export function musicuserfilepropatch(data){
    //get 请求=》params
    return create({
        url:"/music/userfilepro/",
        method:"patch",
        data
    })
}

export function funcsimpleget(params){
    //get 请求=》params
    return create({
        url:"/func/simple/",
        method:"get",
        params:params
    })
}



















export function gamemanuscriptget(params){
    //get 请求=》params
    return create({
        url:"/game/manuscript/",
        method:"get",
        params:params
    })
}
export function gamemanuscriptlableget(params){
    //get 请求=》params
    return create({
        url:"/game/manuscript/lable/",
        method:"get",
        params:params
    })
}

export function gamemanuscriptpost(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/",
        method:"post",
        data
    })
}
export function gamemanuscriptlablepost(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/lable/",
        method:"post",
        data
    })
}

export function gamemanuscriptPUT(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/",
        method:"PUT",
        data
    })
}
export function gamemanuscriptaddlablepost(data){
    //get 请求=》params
    return create({
        url:"/game/manuscriptaddlable/",
        method:"post",
        data
    })
}
export function gamemanuscriptdelete(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/",
        method:"delete",
        data
    })
}
export function gamemanuscriptlabledelete(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/lable/",
        method:"delete",
        data
    })
}












export function campuscategoriesget(params){
    //get 请求=》params
    return create({
        url:`/campus/categories/`,
        method:"get",
        params:params
    })
}
export function campustextbooksget(params){
    //get 请求=》params
    return create({
        url:`/campus/textbooks/${params}/`,
        method:"get",
   
    })
}
export function campusgradesget(params){
    //get 请求=》params
    return create({
        url:`/campus/grades/${params}/`,
        method:"get",
   
    })
}
export function campussemestersget(params){
    //get 请求=》params
    return create({
        url:`/campus/semesters/${params}/`,
        method:"get",
   
    })
}
export function campusunitsget(params){
    //get 请求=》params
    return create({
        url:`/campus/units/${params}/`,
        method:"get",
   
    })
}
export function campuswordsget(params){
    //get 请求=》params
    return create({
        url:`/campus/words/${params}/`,
        method:"get",
   
    })
}


export function campuspromotionhisget(params){
    //get 请求=》params
    return create({
        url:"/campus/promotionhis/",
        method:"get",
        params:params
    })
}



export function orderscategoriespost(data){
    //get 请求=》params
    return create({
        url:"/orders/categories/",
        method:"post",
        data
    })
}





export function funcassemblypost(data){
    //get 请求=》params
    return create({
        url:"/func/assembly/",
        method:"post",
        data
    })
}







export function funcassemblyget(params){
    //get 请求=》params
    return create({
        url:`/func/assembly/`,
        method:"get",
        params:params
    })
}
export function assemblyhisget(params){
    //get 请求=》params
    return create({
        url:`/func/assembly/his/`,
        method:"get",
        params:params
    })
}
export function assemblyhisDELETE(data){
    //get 请求=》params
    return create({
        url:"/func/assembly/his/",
        method:"DELETE",
        data
    })
}
export function funcassemblyhisPUT(data){
    //get 请求=》params
    return create({
        url:"/func/assembly/his/",
        method:"PUT",
        data
    })
}




export function campuspisgget(params){
    //get 请求=》params
    return create({
        url:`/campus/pisg/`,
        method:"get",
        params:params
    })
}

export function campuspisgpost(data){
    //get 请求=》params
    return create({
        url:"/campus/pisg/",
        method:"post",
        data
    })
}
export function gameaccwordpost(data){
    //get 请求=》params
    return create({
        url:"/game/accword/",
        method:"post",
        data
    })
}
export function voiceissper(data){
    //get 请求=》params
    return create({
        url:"/voice/issper/",
        method:"post",
        data
    })
}
export function voicepopuppost(data){
    //get 请求=》params
    return create({
        url:"/voice/popup/",
        method:"post",
        data
    })
}

export function gameaccwzpost(data){
    //get 请求=》params
    return create({
        url:"/game/accwz/",
        method:"post",
        data
    })
}
export function voicepopupPACTH(data){
    //get 请求=》params
    return create({
        url:"/voice/popup/",
        method:"PATcH",
        data
    })
}
// 形象照相馆充值
export function imgTopUp(data){
    //get 请求=》params
     return create({
        url:"/orders/buyimagephotographystudio/",
        method:"post",
        data
    })
}























export function vipgamespost(data){
    //get 请求=》params
    return create({
        url:"/vip/games/",
        method:"post",
        data
    })
}
export function vipgamesget(params){
    //get 请求=》params
    return create({
        url:'/vip/games/',
        method:"get",
        params:params
    })
}
export function vipgameshisget(params){
    //get 请求=》params
    return create({
        url:'/vip/games/his/',
        method:"get",
        params:params
    })
}
export function vipgameshisDELETE(data){
    //get 请求=》params
    return create({
        url:"/vip/games/his/",
        method:"DELETE",
        data
    })
}
export function vipgameshisPUT(data){
    //get 请求=》params
    return create({
        url:"/vip/games/his/",
        method:"PUT",
        data
    })
}


export function vipwordmatrixpost(data){
    //get 请求=》params
    return create({
        url:"/vip/wordmatrix/",
        method:"post",
        data
    })
}
export function vipwordmatrixget(params){
    //get 请求=》params
    return create({
        url:'/vip/wordmatrix/',
        method:"get",
        params:params
    })
}
export function vipwordmatrixgeneratepost(data){
    //get 请求=》params
    return create({
        url:"/vip/wordmatrix/generate/",
        method:"post",
        data
    })
}
export function vipwordmatrixgenerateget(params){
    //get 请求=》params
    return create({
        url:'/vip/wordmatrix/generate/',
        method:"get",
        params:params
    })
}
export function vipwordmatrixhisget(params){
    //get 请求=》params
    return create({
        url:'/vip/wordmatrix/his/',
        method:"get",
        params:params
    })
}
export function vipwordmatrixhisDELETE(data){
    //get 请求=》params
    return create({
        url:"/vip/wordmatrix/his/",
        method:"DELETE",
        data
    })
}
export function vipwordmatrixhisPUT(data){
    //get 请求=》params
    return create({
        url:"/vip/wordmatrix/his/",
        method:"PUT",
        data
    })
}

export function vipprogramming_vocabulary_challengepost(data){
    //get 请求=》params
    return create({
        url:"/vip/programming_vocabulary_challenge/",
        method:"post",
        data
    })
}

export function vipprogramming_vocabulary_challengeget(params){
    //get 请求=》params
    return create({
        url:'/vip/programming_vocabulary_challenge/',
        method:"get",
        params:params
    })
}
export function vipprogramming_vocabulary_challengeDELETE(data){
    //get 请求=》params
    return create({
        url:"/vip/programming_vocabulary_challenge/",
        method:"DELETE",
        data
    })
}
export function vipprogramming_vocabulary_challengePUT(data){
    //get 请求=》params
    return create({
        url:"/vip/programming_vocabulary_challenge/",
        method:"PUT",
        data
    })
}
export function voicepopupget(params){
    //get 请求=》params
    return create({
        url:`/func/culturalreadinguser/`,
        method:"get",
        params:params
    })
}
export function voicepopupdelete(data){
    //get 请求=》params
    return create({
        url:"/func/cultural2/",
        method:"PUT",
        data
    })
}
export function wordMarkdown(data){
    //get 请求=》params
    return create({
        url:"/func/mdword/",
        method:"post",
        data
    })
}
// myIp获取历史记录
export const getDemoData = (params) => {
    //get 请求=》params
    return create({
        url:"/api2/demo-data/",
        method:"get",
        params
    })
}
// myIp生成落地页
export const generateLandingPage = (data) => {
    //get 请求=》params
    return create({
        url:"/api2/generate-landing-page/",
        method:"post",
        data
    })
}
// myIp获取任务状态
export const getTaskStatus = (params) => {
    //get 请求=》params
    return create({
        url:`/api2/task-status/${params}/`,
        method:"get",
        
    })
}
// 图片裁剪接口
export const cropImage = (data) => {
    //get 请求=》params
    return create({
        url:`/api2/crop/`,
        method:"post",
        data
        
    })
}
// 修改html页面接口
export const uploadResponse = (data) => {
    //get 请求=》params
    return create({
        url:`/api2/upload/`,
        method:"post",
        data
        
    })
}

// 生成流利课文点读
export const postPointReading = (data) => {
    //get 请求=》params
    return create({
        url:`/func/fluent/`,
        method:"post",
        data
        
    })
}
// 生成流利课文点读状态查询
export const getPointReading = (params) => {
    //get 请求=》 params
    return create({
        url:`/func/fluent/`,
        method:"get",
        params
    })
}

// 生成流利课文点读状态历史记录/单条详情
export const getPointReadingHis = (params) => {
    //get 请求=》 params
    return create({
        url:`/func/fluent/his/`,
        method:"get",
        params
    })
}

// 删除流利课文点读状态数据
 export const deleteDetailsSentence = (data) => {
    //get 请求=》 params
    return create({
        url:`/func/fluent/his/`,
        method:"delete",
        data
    })
}

// 批量上传接口(词汇)
export function batchUpload(data){
    //get 请求=》params
    return create({
        url:"/game/wordlibrary/csv/",
        method:"post",
        data
    })
}

// 批量上传接口文章
export function batchUploadArticle(data){
    //get 请求=》params
    return create({
        url:"/game/manuscript/csv/",
        method:"post",
        data
    })
}

// 阅读精读2.5历史记录json转html即时生成
export function funcextendthreereusePUT(data){
    //get 请求=》params
    return create({
        url:"/func/tedhtml/",
        method:"put",
        data:data
    })
}

// 语法填空专栏练习（生成）
export function discoursecompletionPost(data){
    //get 请求=》params
    return create({
        url:"/func/discoursecompletion/",
        method:"post",
        data:data
    })
}

// 语法填空专栏练习（获取生成状态）
export function discoursecompletionGet(params){
    //get 请求=》params
    return create({
        url:"/func/discoursecompletion/",
        method:"get",
        params
    })
}

// 语法填空专栏练习（历史记录）
export function getNewBusinessList(params){
    //get 请求=》params
    return create({
        url:"/func/discoursecompletionhistoy/",
        method:"get",
        params
    })
}

// 语法填空专栏练习（删除历史记录）
export function deleteNewBusiness(data){
    //get 请求=》params
    return create({
        url:"/func/discoursecompletionhistoy/",
        method:"delete",
        data
    })
}

// 语法填空专栏练习（查看）
export function updateNewBusiness(data){
    //get 请求=》params
    return create({
        url:"/func/discoursecompletionhistoy/",
        method:"put",
        data
    })
}

// 阅读练习作业纸

export function ReadingExercisesPost(data){
    //get 请求=》params
    return create({
        url:"/func/readingintensivereadingpractice/",
        method:"post",
        data
    })
}

export function ReadingExercisesGet(params){
    //get 请求=》params
    return create({
        url:"/func/readingintensivereadingpractice/",
        method:"get",
        params:params
    })
}

// 获取历史记录查看
export function ReadingExercisesPut(data){
    //get 请求=》params
    return create({
        url:"/func/readingintensivereadingpracticepaperhis/",
        method:"put",
        data:data
    })
}

// 获取历史记录
export function ReadingExercisesList(params){
    //get 请求=》params
    return create({
        url:"/func/readingintensivereadingpracticepaperhis/",
        method:"get",
        params:params
    })
}

// 获取历史记录删除
export function ReadingExercisesDelete(data){
    //get 请求=》params
    return create({
        url:"/func/readingintensivereadingpracticepaperhis/",
        method:"delete",
        data:data
    })
}

// 生成英语写作练习纸
export function WritingExercisesPost(data){
    //get 请求=》params
    return create({
        url:"/func/gaokaozyz/",
        method:"post",
        data
    })
}
// 生成英语写作练习纸获取状态
export function WritingExercisesGet(params){
    //get 请求=》params
    return create({
        url:"/func/gaokaozyz/",
        method:"get",
        params
    })
}

// 生成英语写作练习纸历史记录查看
export function WritingExercisesPut(data){
    //get 请求=》params
    return create({
        url:"/func/gaokaozyzuser/",
        method:"put",
        data:data
    })
}

// 生成英语写作练习纸历史记录获取
export function WritingExercisesList(params){
    //get 请求=》params
    return create({
        url:"/func/gaokaozyzuser/",
        method:"get",
        params:params
    })
}

// 生成英语写作练习纸历史记录删除
export function WritingExercisesDelete(data){
    //get 请求=》params
    return create({
        url:"/func/gaokaozyzuser/",
        method:"delete",
        data:data
    })
}

// 水印相关
export function watermarkEncryption(data, config = {}) { // 1. 接收 config 参数
    return create({
        url: "/func/water/",
        method: "post",
        data,
        ...config // 2. 将 config (如 responseType) 传递给 axios
    })
}

// 图片转文本
export function OcrDialog(data) { 
    return create({
        url: "/func/ocr/",
        method: "post",
        data
    })
}

export function avatarpaperhistorysave(data){
    //get 请求=》params
    return create({
        url:'/avatar/paperhistory2/',
        method:"put",
        data
    })
}

export function EnglishCompositionPUT(data){
    //get 请求=》params
    return create({
        url:'/func/patternput/',
        method:"put",
        data
    })
}

// 并发鉴权
export function IndependentLock(data){
    //get 请求=》params
    return create({
        url:'/Independent/lock/',
        method:"post",
        data
    })
}

// 范文写作分析生成
export function EssayScaffoldingPOST(data){
    //get 请求=》params
    return create({
        url:'/func/writin/',
        method:"post",
        data
    })
}

// 范文写作分析获取结果&贪吃蛇&望远镜&句子生图&自然拼读点读卡
export function EssayScaffoldingGET(params){
    //get 请求=》 params
    return create({
        url:'/func/results/',
        method:"get",
        params
    })
}

// 范文写作分析获取历史记录
export function EssayScaffoldingWritinGET(params){
    //get 请求=》 params
    return create({
        url:'/func/writin/',
        method:"get",
        params
    })
}

// 范文写作分析删除
export function EssayScaffoldingWritinDELETE(data){
    //get 请求=》 params
    return create({
        url:'/func/writin/',
        method:"delete",
        data
    })
}

// 范文写作分析编辑
export function EssayScaffoldingWritinPUT(data){
    //get 请求=》 params
    return create({
        url:'/func/writin/',
        method:"put",
        data
    })
}

// 贪吃蛇游戏
export function greedySnakepost(data){
    //get 请求=》params
    return create({
        url:"/vip/snake/",
        method:"post",
        data
    })
}

// 贪吃蛇游戏
export function greedySnakeget(params){
    //get 请求=》 params
    return create({
        url:"/vip/snake/",
        method:"get",
        params
    })
}

// 贪吃蛇游戏
export function greedySnakeput(data){
    //get 请求=》params
    return create({
        url:"/vip/snake/",
        method:"put",
        data
    })
}

// 望远镜游戏
export function TelescopePOST(data){
    //get 请求=》params
    return create({
        url:"/vip/bool/",
        method:"post",
        data
    })
}

// 望远镜游戏历史
export function TelescopeGET(params){
    //get 请求=》 params
    return create({
        url:"/vip/bool/",
        method:"get",
        params
    })
}

// 望远镜游戏修改备注
export function TelescopePUT(data){
    //get 请求=》params
    return create({
        url:"/vip/bool/",
        method:"put",
        data
    })
}


// 句子生图生成
export function RawImagePOST(data){
    //get 请求=》params
    return create({
        url:'/vip/making/',
        method:"post",
        data
    })
}

// 句子生图历史记录
export function RawImageGET(params){
    //get 请求=》 params
    return create({
        url:'/vip/making/',
        method:"get",
        params
    })
}

// 句子生图删除
export function RawImageDELETE(data){
    //get 请求=》 params
    return create({
        url:'/vip/making/',
        method:"delete",
        data
    })
}

// 句子生图编辑
export function RawImagePUT(data){
    //get 请求=》 params
    return create({
        url:'/vip/making/',
        method:"put",
        data
    })
}

// 句子生图功能增强版生成
export function NEWRawImagePOST(data){
    //get 请求=》 params
    return create({
        url:'/vip/making/img/',
        method:"post",
        data
    })
}

// 长文阅读理解精读生成
export function Reading3_0POST(data){
    //get 请求=》 params
    return create({
        url:'/func/pure/',
        method:"post",
        data
    })
}

// 长文阅读理解精读历史记录获取
export function Reading3_0GET(params){
    //get 请求=》 params
    return create({
        url:'/func/pure/',
        method:"get",
        params
    })
}

// 长文阅读理解精读历史查看
export function Reading3_0PUT(data){
    //get 请求=》 params
    return create({
        url:'/func/pure/',
        method:"put",
        data
    })
}

// 点读卡生成
export function readThePicturePOST(data){
    //get 请求=》 params
    return create({
        url:'/special/clicktoread/',
        method:"post",
        data
    })
}

// 点读卡生成get
export function readThePictureGET(params){
    //get 请求=》 params
    return create({
        url:'/func/results/',
        method:"get",
        params
    })
}

// 点读卡生成历史记录
export function readThePictureclicktoread(params){
    //get 请求=》 params
    return create({
        url:'/special/clicktoread/',
        method:"get",
        params
    })
}

// 点读卡生成get
export function readThePictureDELETE(data){
    //get 请求=》 params
    return create({
        url:'/special/clicktoread/',
        method:"delete",
        data
    })
}

// 点读卡生成get
export function readThePicturePUT(data){
    //get 请求=》 params
    return create({
        url:'/special/clicktoread/',
        method:"put",
        data
    })
}

// 阅读精读练习作业纸(西班牙语版)生成
export function phraseExpansion5POST(data){
    //get 请求=》 params
    return create({
        url:'/work/writin/',
        method:"post",
        data
    })
}
// 阅读精读练习作业纸(西班牙语版)生成1
export function phraseExpansion5GET(params){
    //get 请求=》 params
    return create({
        url:'/work/writin/',
        method:"get",
        params
    })
}

// 阅读精读练习作业纸(西班牙语版)历史记录
export function phraseExpansion5GETS(params){
    //get 请求=》 params
    return create({
        url:'/work/writinhis/',
        method:"get",
        params
    })
}

// 阅读精读练习作业纸(西班牙语版)历史记录查看
export function phraseExpansion5PUT(data){
    //get 请求=》 params
    return create({
        url:'/work/writinhis/',
        method:"put",
        data
    })
}

// 阅读精读练习作业纸(西班牙语版)历史记录删除
export function phraseExpansion5DELETE(data){
    //get 请求=》 params
    return create({
        url:'/work/writinhis/',
        method:"delete",
        data
    })
}

// 图文识别功能接口
export function GenerateImagesPOST(data){
    //get 请求=》 params
    return create({
        url:'/smart/img/',
        method:"post",
        data
    })
}

// 图文识别功能接口1
export function GenerateImagesGET(params){
    //get 请求=》 params
    return create({
        url:'/func/results',
        method:"get",
        params
    })
}

// 图文识别功能历史记录
export function GenerateImagesGETs(params){
    //get 请求=》 params
    return create({
        url:'/smart/img/',
        method:"get",
        params
    })
}

// 图文识别功能获取算力
export function GenerateImagesGETss(params){
    //get 请求=》 params
    return create({
        url:'/smart/computing/',
        method:"get",
        params
    })
}

// 图文识别功能支付
export function GenerateImagesPayment(data){
    //get 请求=》params
     return create({
        url:"/orders/smart_img/",
        method:"post",
        data
    })
}

// 图文识别校验支付是否成功&应急券支付功能校验是否成功
export function GenerateImagesPaymentGET(params){
    return create({
        url:'/orders/skycard/',
        method:"get",
        params
    })
}

// 体验券支付
export function DayCardPaymentPOST(data){
    return create({
        url:'/orders/skycard/',
        method:"post",
        data
    })
}

// 自然拼读点读卡
export function workNatuaphonPOST(data){
    return create({
        url:'/work/natuaphon/',
        method:"post",
        data
    })
}

// 自然拼读点读卡历史
export function workNatuaphonGET(params){
    return create({
        url:'/work/natuaphon/',
        method:"get",
        params
    })
}

// 自然拼读点读卡删除
export function workNatuaphonDELETE(data){
    return create({
        url:'/work/natuaphon/',
        method:"delete",
        data
    })
}

// 听力练习纸请求
export function ListeningPOST(data){
    return create({
        url:'/work/listen/',
        method:"post",
        data
    })
}

// 听力练习纸请求历史记录
export function ListeningEGT(params){
    return create({
        url:'/work/listen/',
        method:"get",
        params
    })
}

// 听力练习纸请求历史记录删除
export function ListeningDELETE(data){
    return create({
        url:'/work/listen/',
        method:"delete",
        data
    })
}



